var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V28H0V0Z",
    fill: "#0A17A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.025L5.08317 18.6671H0V9.33375H5.08523L0 6.97485V2.47163L14.2148 8.6016V0H25.7862V8.59964L40 2.47012V6.97333L34.9115 9.33375H40V18.6671H34.9136L40 21.0265V25.5297L25.7862 19.4002V28H14.2148V19.3983L0 25.5282V21.025Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 4.64582V3.58743L29.16 8.4918C28.8655 8.62504 28.781 8.90017 28.9714 9.10632C29.1617 9.31246 29.5548 9.37157 29.8493 9.23833L40 4.64582Z",
    fill: "#E6273E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9286 0H23.0715V11.1999H40V16.7999H23.0715V27.9999H16.9286V16.7999H0V11.1999H16.9286V0Z",
    fill: "#E6273E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.7537L7.44686 9.20516C7.73924 9.34067 8.13319 9.28461 8.32678 9.07995C8.52037 8.87528 8.44028 8.59952 8.1479 8.46401L0 4.68762V5.7537Z",
    fill: "#E6273E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.326V23.2651L10.0657 18.6745C10.3595 18.5405 10.7528 18.5986 10.9442 18.8043C11.1357 19.01 11.0527 19.2853 10.7589 19.4193L0 24.326Z",
    fill: "#E6273E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22.2406V23.3067L31.8884 19.5466C31.5961 19.4111 31.516 19.1353 31.7096 18.9307C31.9032 18.726 32.2972 18.67 32.5896 18.8055L40 22.2406Z",
    fill: "#E6273E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.28547d9535a734c2b317c20a00a52367.svg";
export { ForwardRef as ReactComponent };